define.alias("shared/components/shared/ui/social-profile-switcher/linkinbio/item", "media/components/shared/ui/social-profile-switcher/linkinbio/item");